import { LocalizationSerializer } from "@serializers/localization"
import { DocumentSerializer } from "@serializers/documents"
import { FeatureTogglesSerializer } from "@serializers/feature-toggles"
import { SmartBannerSerializer } from "@serializers/smart-banner"
import { SpecialProjectsSerializer } from "@serializers/special-projects"

import { BaseHttpProvider } from "./base-http.provider"

import type { LanguageISO } from "@providers"

export class GlobalProvider extends BaseHttpProvider {
  async getGlobal() {
    const data = await this.execute({
      uri: "/global",
    })
    const redirects = await this.getRedirects()
    const featureToggles = await this.getFeatureToggles()
    const specialProjects = await this.getSpecialProjects()

    const publishedVacanciesCounter = await this.getPublishedVacanciesCounter()

    const templates: {
      [key: string]: ReturnType<typeof LocalizationSerializer>[]
    } = {}
    Object.entries(data?.templates).forEach(([lang, values]) => {
      // @ts-ignore
      templates[lang] = values.map((value) => LocalizationSerializer(value))
    })
    return {
      languages: data.languages,
      // TODO: Decide what to do with this code, I see only `language`, `templates` and `branch_links`
      pages: {
        aboutUs: {
          enabled: data?.pages?.about_us?.enabled ?? false,
        },
        faq: {
          enabled: data?.pages?.faq?.enabled ?? false,
        },
        terms: {
          enabled: data?.pages?.terms?.enabled ?? false,
        },
      },
      templates,
      redirects,
      featureToggles,
      specialProjects,
      branchLinks: data.branchLinks,
      publishedVacanciesCounter,
      pressLink: data?.pressLink,
    }
  }

  async getRedirects() {
    const data = await this.execute({ uri: "/redirects" })
    return data
  }

  async getFaq(locale: LanguageISO) {
    const data = await this.execute({
      uri: "/faq",
      // eslint-disable-next-line
      query: { _locale: locale, _sort: "order:asc,created_at:desc" },
    })
    return data.map((document) => DocumentSerializer(document))
  }

  async getFaqPage(locale: string) {
    const data = await this.execute({ uri: "/faq-page", query: { locale } })
    return data
  }

  async getTerms(lang: LanguageISO) {
    const data = await this.execute({ uri: "/terms", query: { lang } })
    return data.map((document) => DocumentSerializer(document))
  }

  async getPrivacy(lang: LanguageISO) {
    const data = await this.execute({ uri: "/privacies", query: { lang } })
    return data.map((document) => DocumentSerializer(document))
  }

  async getSecurity(lang: LanguageISO) {
    const data = await this.execute({
      uri: "/securities",
      query: { lang: lang === "zh" ? "ch" : lang },
    })
    return data.map((document) => DocumentSerializer(document))
  }

  async getGuideline(lang: LanguageISO) {
    const data = await this.execute({
      uri: "/guidelines",
      query: { lang: lang === "zh" ? "ch" : lang },
    })
    return data.map((document) => DocumentSerializer(document))
  }

  async getFeatureToggles() {
    const data = await this.execute({ uri: "/feature-toggles" })
    return FeatureTogglesSerializer(data)
  }

  async getSmartBanner(locale: LanguageISO) {
    const data = await this.execute({
      uri: "/smart-banner",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      query: { _locale: locale },
    })
    return SmartBannerSerializer(data)
  }

  async getSpecialProjects(/*locale: LanguageISO*/) {
    const data = await this.execute({
      uri: "/special-projects",
      //query: { lang: locale },
    })
    return SpecialProjectsSerializer(data)
  }
  async getPublishedVacanciesCounter() {
    const { vacancies } = await this.execute({
      uri: "/vacancies-v2",
    })

    return vacancies.length
  }
}
